import { render, staticRenderFns } from "./TestReceivedList.vue?vue&type=template&id=b69a063c&"
import script from "./TestReceivedList.vue?vue&type=script&lang=js&"
export * from "./TestReceivedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports